import { useAppDispatch } from '../../../../store';
import { claimChestReward, getActiveChests } from '../../../../store/reducers/chests/asyncActions';
import { getMe } from '../../../../store/reducers/profile/asyncActions';
import { TChestRewardHistory } from '../../../../types';
import ChesSpinContent from '../ChesSpinContent';
import CollectChestReward from '../CollectReward';

type ChestContentProps = {
  setRewardToCollect: (reward: TChestRewardHistory | undefined) => void;
  rewardToCollect: TChestRewardHistory | undefined
}
function ChestContent({ rewardToCollect, setRewardToCollect }: ChestContentProps) {
  const dispatch = useAppDispatch();

  const onCollect = async () => {
    if (!rewardToCollect) {
      return;
    }

    const result = await dispatch(claimChestReward({ id: rewardToCollect.chest_history_id.toString() }));

    if (result.error) {
      return;
    }

    setRewardToCollect(undefined);

    dispatch(getMe());
    dispatch(getActiveChests());
  };

  return (
    <>
      <div className={rewardToCollect ? 'hidden' : undefined}>
        <ChesSpinContent onFinish={setRewardToCollect} />
      </div>

      <div className={!rewardToCollect ? 'hidden' : undefined}>
        <CollectChestReward reward={rewardToCollect} onCollect={onCollect} />
      </div>
    </>
  );
}

export default ChestContent;
